module.exports = "<div *ngIf=\"visible\" class=\"spinner\">\n\t<div class=\"backdrop\"></div>\n\t<div class=\"middle\">\n\t\t<div class=\"loader\" [ngClass]=\"{'dark-loader': middleText}\">Loading...</div>\n\t\t<div class=\"middle-text\" *ngIf=\"middleText\">{{middleText}}</div>\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-helper/spinner/spinner.html
// module id = 4NBx
// module chunks = 12